import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Context from '../Context';

const AddFreeItemModal = ({ item, modal, setModal }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [disabledAddToCart, setDisabledAddToCart] = useState(false);
  const [alertMessages, setAlertMessages] = useState({});
  const [special_instructions, setSpecialInstructions] = useState('');
  const { language, setChangedCart, changedCart, restaurantId } = useContext(Context);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    if (!modal) {
      // Reset state when modal is closed
      setSelectedOptions([]);
      setDisabledAddToCart(false);
      setAlertMessages({});
      setSpecialInstructions('');

    }
  }, [modal]);

  useEffect(() => {
    const checkRequiredOptions = () => {
      let allOptionsSelected = true;
      let alerts = {};

      item?.Restaurant_Item_Attributes.forEach((attribute) => {
        const requiredOptions = attribute?.Item_Attribute?.requ || 0;
        const selectedOptionsCount = selectedOptions.filter(opt => opt.attributeId === attribute.id).length;

        if (requiredOptions > selectedOptionsCount || requiredOptions !== selectedOptionsCount && requiredOptions !== 0) {
          allOptionsSelected = false;
          alerts[attribute.id] = `*Must Select ${requiredOptions} options and you selected ${selectedOptionsCount}`;
        } else {
          alerts[attribute.id] = '';
        }
      });

      setAlertMessages(alerts);
      setDisabledAddToCart(!allOptionsSelected);
    };

    checkRequiredOptions();
  }, [selectedOptions, item]);



  const handleOptionChange = (optionId, priceModifier, attributeId) => {
    const existingOption = selectedOptions.find((opt) => opt.id === optionId);

    if (existingOption) {
      // If the option is already selected, remove it
      setSelectedOptions((prevOptions) =>
        prevOptions.filter((opt) => opt.id !== optionId)
      );
    } else {
      // If the option is not selected, add it
      setSelectedOptions((prevOptions) => [
        ...prevOptions,
        { id: optionId, priceModifier, attributeId },
      ]);
    }
  };


  const handleAddItem = () => {
    try {
      setIsLoading(true);
  
      // Retrieve the cart from localStorage, or initialize it if it doesn't exist
      let cart = JSON.parse(localStorage.getItem(`freeItem`)) || {}
  
      // Create the item to add
      const itemToAdd = {
        Item: item,
        special_instructions: special_instructions,
        options: selectedOptions,
        price: 0.00,
      };

      cart = itemToAdd;
  
      // Assign the itemToAdd to the freeItem property in the cart object
      
  
      // Save the updated cart back to localStorage
      localStorage.setItem(`freeItem`, JSON.stringify(cart));
  
      // Reset states
      setIsLoading(false);
      setSpecialInstructions('');
      setSelectedOptions([]);
      setModal(false);
      setChangedCart(!changedCart);
  
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };
  
  
  

  return (
    <Modal show={modal} onHide={() => setModal(false)} centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{language === 'en' ? item?.name : item?.chinese_name}(Free Item)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column align-items-center">
          {item?.image_url && (
            <img
              src={item?.image_url}
              alt={language === 'en' ? item?.name : item?.chinese_name}
              className="img-fluid mb-3"
              style={{ width: '100%', maxHeight: '220px', objectFit: 'cover' }}
            />
          )}
          {item?.description && item?.description !== 'null' && (
            <p>{item?.description}</p>
          )}
          {item?.Restaurant_Item_Attributes && item.Restaurant_Item_Attributes.length > 0 && (
            <div className="w-100">
              <h6>Options:</h6>
              <Form>
                {item?.Restaurant_Item_Attributes?.map((attribute) => (
                  <Form.Group key={attribute.id} className="mb-3">
                    <Form.Label className="mb-2">{attribute?.Item_Attribute?.name} <br />
                      <small className="text-danger">{alertMessages[attribute.id]}</small>
                    </Form.Label>

                    <div className="d-flex flex-wrap">
                      {attribute?.Item_Attribute?.Item_Attribute_Options?.map((option) => (
                        <div className='checkbox-wrapper-47 m-0' key={option.id}>
                          <input
                            type="checkbox"
                            id={option.name}
                            name={option.name}
                            value={option.id}
                            onChange={() => handleOptionChange(option.id, option.price_modifier, attribute.id)}
                          />
                          <label htmlFor={option.name}>{option.name}</label>
                        </div>
                      ))}
                    </div>
                  </Form.Group>
                ))}
              </Form>
            </div>
          )} 
          <Form.Group className="w-100 mb-3">
            <Form.Label>Special Instructions:</Form.Label>
            <Form.Control value={special_instructions} onChange={(e) => setSpecialInstructions(e.target.value)} type="text" placeholder="Add special instructions..." />
          </Form.Group>
      
        </div>
      </Modal.Body>
  <div style={{ flex: '1', textAlign: 'right' }}>
  <div className="col-md-12" style={{ backgroundColor: '#28a745', color: 'white', padding: '10px', textAlign: 'center', cursor: 'pointer' }} onClick={handleAddItem}>
  {isLoading ? 'Adding...' : 'Add to Cart (0.00)'}
  </div>
  </div>



    </Modal>
  );
};

export default AddFreeItemModal;
